import { initials } from '../lib/format.ts'
import { cn } from '../lib/cn.ts'

export function Avatar({ name, className }: { name: string; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex size-7 shrink-0 items-center justify-center rounded-full bg-[#e2e6de] text-[12px] font-semibold text-[#3f4a3f]',
        className,
      )}
    >
      {initials(name)}
    </span>
  )
}
